'use strict';

exports.__esModule = true;
exports.get = undefined;

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CSR_JOBS: '/csr/jobs'
};

var get = exports.get = function get(_ref) {
  var id = _ref.id;

  var endpoint = id ? API.CSR_JOBS + '/' + id : API.CSR_JOBS;
  return _http2.default.get(endpoint);
};

var jobs = {
  get: get
};

exports.default = jobs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/csr/jobs.js
// module id = 1097
// module chunks = 0